import { Table } from "@/components/Tables/models/Table";
import { TablesJsonParsingInputType } from "@/components/Tables/services/TablesJsonParsingService";
import { IQueueExecutionCustomTablesProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { SchemaCoalesceService } from "./SchemaCoalesceService";


export class TablesSchemaCoalesceService extends SchemaCoalesceService<Table, TablesJsonParsingInputType, IQueueExecutionCustomTablesProp> {

    public coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<Table, TablesJsonParsingInputType>): IQueueExecutionCustomTablesProp {
        if (parsingResult == null) throw Error("parsingResult is required");
        if (!parsingResult.valid) throw Error("valid parsingResult required");

        const coalesceResult: IQueueExecutionCustomTablesProp = {
            tables: parsingResult.parsedEntities ?? []
        };

        return coalesceResult;
    }

}
